var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { loaderHandler, setDisabledButton, returnCheckedDocumentsIds, showErrorAlert } from './helpers';
export const checkboxesHandler = () => {
    const checkboxes = document.querySelectorAll('.js-accessible-docs-checkbox');
    if (checkboxes.length > 0) {
        checkboxes.forEach((checkbox) => {
            checkbox.addEventListener('change', () => {
                const checkedValues = returnCheckedDocumentsIds();
                const disabled = checkedValues ? false : true;
                setDisabledButton('.js-remove-selected-button', disabled);
            });
        });
    }
};
const handleDeleteSelectedDocuments = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const selectedIds = returnCheckedDocumentsIds();
        if (!selectedIds) {
            showErrorAlert(`No documents selected`);
        }
        const formData = new FormData();
        formData.append('action', 'accessible_docs_delete_selected');
        formData.append('nonce', accessible_docs_object.nonce);
        formData.append('selectedIds', selectedIds.toString());
        const response = yield fetch(accessible_docs_object.ajax_url, {
            method: 'POST',
            body: formData,
        });
        if (!response.ok) {
            showErrorAlert(`Request failed with status: ${response.status}`);
            throw new Error(`Request failed with status: ${response.status}`);
        }
        const result = yield response.json();
        return result.data;
    }
    catch (error) {
        throw new Error(`Error: ${error}`);
    }
});
const deleteSelectedDocumentsHandler = () => {
    const deleteButton = document.querySelector('.js-remove-selected-button');
    if (deleteButton) {
        deleteButton.addEventListener('click', () => __awaiter(void 0, void 0, void 0, function* () {
            const selectedIds = returnCheckedDocumentsIds();
            if (selectedIds && window.confirm(deleteButton.dataset.text)) {
                loaderHandler('add');
                const request = yield handleDeleteSelectedDocuments();
                if (request.status === 'success') {
                    window.location.href = `${window.location.origin}${window.location.pathname}?page=accessible-docs-admin-documents-list`;
                }
                else {
                    loaderHandler('remove');
                    alert(request.error);
                }
            }
        }));
    }
};
const initDeleteSelectedDocementsHandler = () => {
    checkboxesHandler();
    deleteSelectedDocumentsHandler();
};
export default initDeleteSelectedDocementsHandler;
